import { render, staticRenderFns } from "./EditSuiviDialog.vue?vue&type=template&id=464e63fa&"
import script from "./EditSuiviDialog.vue?vue&type=script&lang=ts&"
export * from "./EditSuiviDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports